import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Container } from '@mui/material';
import Landing from './components/Landing/Landing';
import FileUpload from './components/FileUpload/FileUpload';
import DataUploadForm from './components/DataUploadForm/DataUploadForm';
import JobStatus from './components/FileUpload/JobStatus';
import JobsList from './components/FileUpload/JobsList';
import './styles/app.css';

const theme = createTheme({
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 605,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '10px 24px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
          },
        },
      },
    },
  },
});

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/file-upload" element={
            <Box className="app-container">
              <Container maxWidth="md" className="main-container">
                <FileUpload />
              </Container>
            </Box>
          } />
          <Route path="/upload" element={<DataUploadForm />} />
          <Route path="/jobs/:jobId" element={<JobStatus />} />
          <Route path="/jobs" element={
            <Box className="app-container">
              <Container maxWidth="md" className="main-container">
                <JobsList />
              </Container>
            </Box>
          } />
        </Routes>
      </ThemeProvider>
    </Router>
  );
}

export default App;
